<template>
  <main class="home">
    <UnitsTable :units="units"/>
  </main>
</template>

<script>
// @ is an alias to /src
import UnitsTable from '@/components/UnitsTable.vue'
import axios from "axios";

export default {
  name: 'Home',
  components: {
    UnitsTable
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    authToken: function () {
      return this.$store.getters.authToken
    }
  },
  watch: {
    authToken: function (val) {
      console.log('changed',val)
      this.units = [];
      this.init();
    }
  },
  data() {
    return {
      units: []
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function() {
      this.getUnits(this.authToken)
          .then((getUnitsDetails) => {
            console.log('getUnits details', getUnitsDetails)
            if (getUnitsDetails.result) {
              this.units = getUnitsDetails.details.units;
              this.$store.dispatch('updateProject', getUnitsDetails.details.name)
            }
          })
          .catch(err => {
            console.log(err)
            this.logout()
          })
    },
    getUnits: function (authToken) {
      return new Promise((resolve, reject) => {
        axios({
          url: 'https://admin.giraffapp.com/giraffweb_get_units?authToken=' + authToken,
          method: 'GET'
        }).then(resp => {
          // console.log('giraffweb_get_units response:', resp)
          if (resp.data.result) {
            const unitsData = resp.data
            resolve(unitsData)
          } else {
            reject('home GetUnits Failed')
          }

        }).catch(err => {
          reject(err)
        })
      })
    },
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  },
}
</script>
<style lang="sass" scoped>
</style>
